import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import moment from "moment";

const useUserSubscription = () => {
  const userSubscriptions = useAppSelector(
    (state) => state.user.currentUser?.subscriptions,
  );

  const activeSubscriptions = userSubscriptions?.filter((subscription) =>
    moment(subscription.endDate).isSameOrAfter(moment()),
  );

  const expiredSubscriptions = userSubscriptions?.filter((subscription) =>
    moment(subscription.endDate).isBefore(moment()),
  );

  const activeSubscriptionsCount = activeSubscriptions?.length;
  const expiredSubscriptionsCount = expiredSubscriptions?.length;

  const activeSubscriptionsList = activeSubscriptions
    ?.sort((a, b) =>
      (a.program?.title ?? "").localeCompare(b.program?.title ?? ""),
    )
    ?.map((subscription) => subscription.program?.title)
    .join(", ");

  const expiredSubscriptionsList = expiredSubscriptions
    ?.sort((a, b) =>
      (a.program?.title ?? "").localeCompare(b.program?.title ?? ""),
    )
    ?.map((subscription) => subscription.program?.title)
    .join(", ");

  return {
    activeSubscriptionsList,
    expiredSubscriptionsList,
    activeSubscriptionsCount,
    expiredSubscriptionsCount,
  };
};

export default useUserSubscription;
